import React from 'react';
import styled, { DefaultTheme } from 'styled-components';
import { PaddingProps, space } from 'styled-system';

import { Padding } from 'src/packages/core';
import { TableColumn } from './Table.types';

export const TableContainer = styled((props) => <Padding {...props} />)<
  PaddingProps & {
    defaulttheme: DefaultTheme;
    highlighted: boolean;
    borderRadius: string;
  }
>`
  direction: ltr;
  width: 100%;
  height: max-content;
  overflow-x: auto;
  background-color: ${({ defaulttheme }) => defaulttheme.colors.background.secondary.BG1};
  border-radius: ${({ borderRadius }) => borderRadius};
  ${space};

  &::-webkit-scrollbar {
    height: 5px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ defaulttheme }) => defaulttheme.colors.background.secondary.BG4};
    border-radius: 10px;
  }

  table {
    width: max-content;
    min-width: 100%;
    border-spacing: 0;
    background-color: ${({ defaulttheme }) => defaulttheme.colors.background.secondary.BG1};
  }

  th,
  td {
    padding: 16px;
    vertical-align: middle;
  }

  th {
    border-bottom: 1px solid ${({ defaulttheme }) => defaulttheme.colors.border.lighter};
  }

  thead > tr {
    th:last-of-type {
      span {
        text-align: right;
      }
    }
  }

  tbody > tr {
    &:hover {
      background-color: ${({ defaulttheme, highlighted }) =>
        highlighted ? defaulttheme.colors.background.secondary.BG3 : 'initial'};

      &.clickable {
        cursor: pointer;

        * {
          cursor: pointer;
        }
      }
    }

    td:last-of-type {
      * {
        justify-content: flex-end;
      }
    }
  }

  ${({ theme }) => theme.mediaQueries.md} {
    .sticky-first-cell {
      position: -webkit-sticky;
      position: sticky;
      left: 0;
      z-index: 1000;
      background-color: white;
    }

    .sticky-last-cell {
      position: -webkit-sticky;
      position: sticky;
      right: 0;
      z-index: 1000;
      background-color: white;
    }
  }
`;

export const THeadContentWrapper = styled.div<TableColumn>`
  display: flex;
  width: ${(props) => props.width ?? '100%'};
  align-items: center;
  position: relative;
`;

export const THeadSortIconWrapper = styled.div`
  display: flex;
  width: auto;
  align-items: center;
  position: absolute;
  right: -14px;
  top: 50%;
  transform: translateY(-50%);
`;

export const RowItemCellContent = styled.div<TableColumn>`
  display: flex;
  align-items: center;
  direction: ltr;
  width: 100%;
  justify-content: ${(props) =>
    props.alignment
      ? props.alignment === 'left'
        ? 'flex-start'
        : props.alignment === 'right'
        ? 'flex-end'
        : 'center'
      : 'flex-start'};
`;

//TODO check disabled colors for dark theme (too dark color)
